import { getAuthData } from '../../utils/authUtils';
import AuthorizeContainer from './AuthorizeContainer';
import SelectAccountContainer from './SelectAccountContainer';
// @ts-expect-error untyped import from ui-addon-iframeable
import UIEmbeddedComponent from 'ui-addon-iframeable/embed/UIEmbeddedComponent';
import EmbeddedContext from '../../utils/EmbeddedContext';
import isEmbedded from '../../utils/isEmbedded';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectAppContainer = ({
  allowParentRedirect,
  embeddedContext
}) => {
  const {
    portal
  } = getAuthData();
  if (portal) {
    if (isEmbedded) {
      return /*#__PURE__*/_jsx(EmbeddedContext.Provider, {
        value: {
          allowParentRedirect: !!allowParentRedirect,
          sendMessage: embeddedContext.sendMessage
        },
        children: /*#__PURE__*/_jsx(AuthorizeContainer, {})
      });
    } else {
      return /*#__PURE__*/_jsx(AuthorizeContainer, {});
    }
  } else {
    return /*#__PURE__*/_jsx(SelectAccountContainer, {});
  }
};
export const EmbeddedAppContainer = UIEmbeddedComponent(ConnectAppContainer, {
  enableTopLevelEmbed: true
});
export const AppContainer = ConnectAppContainer;